/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { List, Icon } from '@mairistem/composants';
import { unformatPhoneNumber } from '@/utils';

interface CoordonneesProps {
  /** Numéro de téléphone */
  telephone?: string;
  /** Courriel */
  mail?: string;
}

const Coordonnees = ({ telephone, mail }: CoordonneesProps) => {
  const displayTelephone = telephone && telephone !== '0' && telephone !== '00';
  const displayMail = mail && mail !== '0' && mail !== '00';

  return (
    <List>
      {displayTelephone && (
        <List.Description>
          <Icon name="phone" /> {unformatPhoneNumber(telephone)}
        </List.Description>
      )}
      {displayMail && (
        <List.Description>
          <Icon name="mail" /> {mail}
        </List.Description>
      )}
    </List>
  );
};

export default Coordonnees;
